import {shopifyFormatCurrency} from 'sections/bundle-builder/formatMoney';

export const UPDATE_SELECTED_PRODUCTS = 'updateSelectedProducts';
export const SELECTED_PRODUCTS_KEY = 'selectedProducts';
export const DISCOUNT_THRESHOLDS = [3500, 4000, 5000];
export const DISCOUNT_PERCENTAGES = [10, 15, 20];

export function getVariantIdQueryParams() {
    return new URLSearchParams(window.location.search).getAll('variantId');
}

export function getTotalPrice() {
    const selectedProducts = sessionStorage.getItem(SELECTED_PRODUCTS_KEY);
    if (!selectedProducts) return 0;
    const parsedSelectedProducts = JSON.parse(selectedProducts);
    return Object.values(parsedSelectedProducts).reduce((total, product) => total + parseFloat(product.price), 0);
}

export function formatPrice(price) {
    let priceFormat = '${{amount}}';
    if (price.endsWith('00')) {
        priceFormat = '${{amount_no_decimals}}';
    }

    return shopifyFormatCurrency(price, priceFormat);
}
